export default __webpack_public_path__ + "static/media/mail-inquiry.0279d82a.webp";